import * as React from 'react';

import * as UI from 'core/ui';

import { Res } from 'core/api';
import { Keypad, ThemeManager, ValueButtonGrid } from 'pos/ui';

import UpdateTipsScreen from './UpdateInvoiceTipsScreen.Common';
import { Flex } from 'core/ui';

export default class Tablet extends UpdateTipsScreen {

	protected useKeypad(): boolean {
		return false;
	}

	protected getContent(): React.ReactNode {
		const { Form, DecimalBox } = UI.controlsFor<typeof this.state>();

		return <Flex.Horizontal>
			<Flex.Item size='*'>
				<Flex.Vertical>
					<Flex.Item className='m-t-md m-b-sm m-l font-bold'>
						{Res.Web.UPDATE_INVOICE_TIP_ADD_LBL()}
					</Flex.Item>
					<Flex.Item>
						<Form ref={this.form} model={this.state} style={{ maxWidth: '10em' }} className='m-l'>
							<DecimalBox ref={this.txtAmount} linkTo={x => x.currentAmount} precision={2} allowNegative={false} />
						</Form>
					</Flex.Item>
					<Flex.Item size='*'>
						<ValueButtonGrid rows='fill' values={this.props.availableMethods} onValueSelected={this.add} />
					</Flex.Item>
					<Flex.Item style={{ width: 325 }}>
						<Keypad isFullScreen={false} isLargeDevice={ThemeManager.isLargeDevice()} alwaysVisible />
					</Flex.Item>
				</Flex.Vertical>
			</Flex.Item>
			<Flex.Item size='325px'>
				{this.createTipList()}
			</Flex.Item>
		</Flex.Horizontal>;
	}
}